
    import './styles.scoped.css';
    export default {
  "divider": "awsui_divider_1noo2_c7ybi_9",
  "divider-horizontal": "awsui_divider-horizontal_1noo2_c7ybi_45",
  "divider-has-label": "awsui_divider-has-label_1noo2_c7ybi_52",
  "divider-line": "awsui_divider-line_1noo2_c7ybi_61",
  "divider-label": "awsui_divider-label_1noo2_c7ybi_68",
  "divider-vertical": "awsui_divider-vertical_1noo2_c7ybi_74"
};
  